export default "__VITE_ASSET__CVSaDOtw__"